import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ label, title, subtitle, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-14 md:mb-20`}>
    <FadeUp>
      <p className="section-label mb-5">— {label}</p>
    </FadeUp>
    <FadeUp delay={0.08}>
      <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight leading-[1.05]">{title}</h2>
    </FadeUp>
    {subtitle && (
      <FadeUp delay={0.16}>
        <p className="text-[var(--text-secondary)] text-base md:text-lg mt-5 leading-relaxed">{subtitle}</p>
      </FadeUp>
    )}
  </div>
);
